import { I2cSelect, I2cRadioGroup, I2cRadioButton, I2cMenuItem
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import "../../PrepaidComponents/Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchema } from "./ValidationSchema";
import AppSelectionIcons from "../../CholderCreditForm/AppSelectionForProgram/AppSelectionIcons"
import USFlag from "../../../assets/images/Flags/US_flag.svg";
import TryFlag from "../../../assets/images/Flags/Turkey_flag.svg";
import AedFlag from "../../../assets/images/Flags/AED_flag.svg";
const MultiCurrency = ({
    type,
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {
    const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
    const currencies = ["USD", "EUR", "PKR"];
    const multiCurrencies = [
        {
            value: "USD",
            flag: USFlag
        },
        {
            value: "TRY",
            flag: TryFlag
        },
        {
            value: "AED",
            flag: AedFlag
        },
    ]
    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onChange",
        reValidateMode: "onChange",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            multicurrency_card_offer_multicurrency: "Yes",
            multicurrency_card_main_currency: "",
            multicurrency_card_supported_currency: []
        },
    });

    const fields = [
        "multicurrency_card_offer_multicurrency",
        "multicurrency_card_main_currency",
        "multicurrency_card_supported_currency" 
    ];

    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            fields.forEach((field) => {
                methods.setValue(field, formDataJson[2]["2_0"][field] ?? "");
            });
            methods.trigger();
            handleValueChanges();
        }
    }, [isFetching]);

    // Controlls destructuring from the method
    const {
        control,
        formState: { errors },
    } = methods;

    // Trigger validation when component mounts
    React.useEffect(() => {
        methods.trigger();
    }, []);

    const handleValueChanges = () => {
        const values = methods.getValues();
        setAddFormData({
            ...addFormData,
            2: {
                ...addFormData["2"],
                "2_0": { ...values },
            },
        });
    };

    React.useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (errorsLength === 0) setFormValidStates("2_0", true);
        else setFormValidStates("2_0", false);
    }, [Object.keys(errors)?.length]);

    return (
        <React.Fragment>
            <div className="forms-instance">
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="9@md">
                        <div className="sub-heading mb-4">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Multi-Currency
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                        <div className="custom-label">
                            i2c offers multi-currency card products as well. A multi-currency card has a main currency account along with other currency accounts
                        </div>
                    </div>
                    <div i2c-grid="12">
                        <div className="single-field-wrapper">
                            <Controller
                                name="multicurrency_card_offer_multicurrency"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Please specify if you want to offer a multi-currency card program."
                                        {...field}
                                        name="multicurrency_card_offer_multicurrency"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            methods.trigger();
                                            handleValueChanges();
                                        }}

                                    >
                                        {["Yes", "No"].map((bc, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("multicurrency_card_offer_multicurrency") === bc
                                                }
                                                value={bc}
                                            >
                                                {bc}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.multicurrency_card_offer_multicurrency &&
                                        methods.formState.touchedFields.multicurrency_card_offer_multicurrency
                                        ? true
                                        : false
                                }
                                message={errors.multicurrency_card_offer_multicurrency?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    <div i2c-grid="12@md" className="halfWidth">
                        <div className="single-field-wrapper">
                            <Controller
                                name="multicurrency_card_main_currency"
                                control={control}
                                render={({ field }) => (
                                    <div className="box-wrap">
                                        <div className="box">
                                            <I2cSelect
                                                {...field}
                                                size="large"
                                                help-text=""
                                                label="Please specify the main currency for your card program."
                                                placeholder="Select currency"
                                                clearable
                                                onI2cChange={(e) => {
                                                    methods.setValue("multicurrency_card_main_currency", e.target.value);
                                                     field.onChange(e);
                                                     methods.trigger();
                                                    handleValueChanges();
                                                }}
                                                // onI2cChange={(e) => {
                                                //     methods.setValue("multicurrency_card_main_currency", e.target.value);
                                                //     // field.onChange(e);
                                                //     methods.trigger();
                                                //     handleValueChanges();
                                                // }}
                                                >
                                                {currencies.map((bc, index) => (
                                                    <I2cMenuItem value={bc}>{bc}</I2cMenuItem>
                                                ))}
                                            </I2cSelect>
                                        </div>
                                    </div>
                                )}

                            />
                            <ErrorMessage
                                show={
                                    errors.multicurrency_card_main_currency &&
                                        methods.formState.touchedFields.multicurrency_card_main_currency
                                        ? true
                                        : false
                                }
                                message={errors.multicurrency_card_main_currency?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("multicurrency_card_offer_multicurrency") === "Yes" && (
                            <div i2c-grid="12@md" className="halfWidth">
                                <div className="single-field-wrapper">
                                    <div className="custom-label mb-8">
                                        Specify all the currencies you want to support. Specify the currencies in the order in which wallets will
                                        be accessed to pay for a non-sufficient funds transaction.
                                    </div>
                                    <Controller
                                        name="multicurrency_card_supported_currency"
                                        control={control}
                                        render={({ field }) => (
                                            <div className="box-wrap">
                                                <div className="box">
                                                    <I2cSelect
                                                        {...field}
                                                        name="multicurrency_card_supported_currency"
                                                        help-text=""
                                                        label=""
                                                        placeholder="Select currency"
                                                        size="large"
                                                        search
                                                        multiple
                                                        onI2cChange={(e) => {
                                                            field.onChange(e);
                                                            methods.trigger();
                                                            handleValueChanges();
                                                        }}
                                                       value={methods.watch("multicurrency_card_supported_currency")}
                                                    >
                                                        {multiCurrencies.map((bc, index) => (
                                                            <I2cMenuItem key={index} value={bc.value}>
                                                                <i2c-avatar
                                                                    image={bc.flag}
                                                                    part="avatars"
                                                                    label={bc.value}
                                                                ></i2c-avatar>
                                                                {bc.value}
                                                            </I2cMenuItem>
                                                        ))}
                                                        <i2c-icon slot="suffix" name="cs-linear-search"></i2c-icon>

                                                    </I2cSelect>
                                                </div>
                                            </div>
                                        )}

                                    />
                                    <ErrorMessage
                                        show={
                                            errors.multicurrency_card_supported_currency &&
                                                methods.formState.touchedFields.multicurrency_card_supported_currency
                                                ? true
                                                : false
                                        }
                                        message={errors.multicurrency_card_supported_currency?.message ?? "Invalid input"}
                                    />
                                </div>
                            </div>
                        )
                    }

                </div>
            </div>
        </React.Fragment>
    );
};
export default MultiCurrency;